import React, { ReactElement } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { useAtlasRelativeUrl } from '../hooks';
import { GuardedRoute } from './atoms';

import {
	AtlasViewer,
	ComparisonPage,
	BosatlasPage,
	BosatlasBundlesPage,
	BundleContentPage,
	SearchResultPage,
	ContentManagerPage,
	IndexPage,
	StartPage,
	UnauthorizedPage
} from './pages';

export function Routing(): ReactElement {
	const atlasRelativeUrl = useAtlasRelativeUrl();
	if (atlasRelativeUrl) return <Redirect to={atlasRelativeUrl} />;

	return (
		<Switch>
			<Route exact path="/map/:mapId">
				<AtlasViewer />
			</Route>
			<Route exact path="/project/:projectId">
				<AtlasViewer />
			</Route>
			<Route exact path="/comparison/:comparisonId?">
				<ComparisonPage />
			</Route>
			<Route exact path="/map/:comparisonMapId/comparison">
				<AtlasViewer />
			</Route>
			<Route exact path="/MijnBosatlas">
				<BosatlasPage />
			</Route>
			<Route exact path="/MijnBosatlas/bundles">
				<BosatlasBundlesPage />
			</Route>
			<Route exact path="/MijnBosatlas/:bundleId">
				<BundleContentPage />
			</Route>

			<Route exact path="/MijnWereldatlas">
				<BosatlasPage />
			</Route>
			<Route exact path="/MijnWereldatlas/bundles">
				<BosatlasBundlesPage />
			</Route>
			<Route exact path="/MijnWereldatlas/:bundleId">
				<BundleContentPage />
			</Route>

			<Route exact path="/search">
				<SearchResultPage />
			</Route>
			<GuardedRoute path="/manage">
				<ContentManagerPage />
			</GuardedRoute>
			<Route exact path="/chapter/:chapterId">
				<IndexPage />
			</Route>
			<Route exact path="/region/:regionId">
				<IndexPage />
			</Route>
			<Route exact path="/theme/:themeId">
				<IndexPage />
			</Route>
			<Route exact path="/content">
				<IndexPage />
			</Route>
			<Route exact path="/">
				<StartPage />
			</Route>
			<Route exact path="/unauthorized">
				<UnauthorizedPage />
			</Route>
		</Switch>
	);
}
